export const useScrollingToTarget = () => useState<boolean>('scrollingToTarget', () => false);